import * as actionTypes from '../../actions/auth/actionTypes';

export const initialState = {
  accessToken: "",
  refreshToken: "",
  user: {},
  registerMessage: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_AUTH_DATA:
      return {
        ...state,
        accessToken: action.data.tokens.accessToken,
        refreshToken: action.data.tokens.refreshToken
      };
    case actionTypes.SET_USER_INFO: {
      return {
        ...state,
        user: (action?.data ?? {}),
      }
    }
    case actionTypes.SET_REGISTER_USER_MESSAGE: {
      console.log(action?.registerMessage)
      return {
        ...state,
        registerMessage: (action?.registerMessage ?? ""),
      }
    }
    default:
      return state;
  }
};

export default authReducer;
